import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiBaseUrl;

export const ApiRoutes = {
  AUTH: {
    SIGN_IN: `${BASE_URL}/auth/signin`,
    SIGN_UP: `${BASE_URL}/auth/signup`,
    FORGOT_PASSWORD: `${BASE_URL}/auth/forgotpassword`,
    VERIFY_OTP: `${BASE_URL}/auth/verifyotp`,
    RESET_PASSWORD: `${BASE_URL}/auth/resetpassword`,
  },
  CART: {
    GET_USER_CART_BY_IDENTIFIER: (
      user_identifier: number,
      purchaseType: 'raffle' | 'subscription'
    ) => `${BASE_URL}/usercart/${user_identifier}?purchaseType=${purchaseType}`,
    ADD_TO_CART: `${BASE_URL}/usercart/addtocart`,
    UPDATE_USER_CART_BY_IDENTIFIER: (cart_identifier: number) =>
      `${BASE_URL}/usercart/${cart_identifier}`,
    DELETE_USER_CART_BY_IDENTIFIER: (cart_identifier: number) =>
      `${BASE_URL}/usercart/${cart_identifier}`,
  },
  MEDIA: {
    ADD_MEDIA: `${BASE_URL}/media/addmedia`,
    GET_INFLUECER_OWN_POSTS: (username: string, pageNumber: number) =>
      `${BASE_URL}/media/getInfluencerMedia?UserName=${username}&PageNumber=${pageNumber}`,
    GET_INFLUECER_POSTS_BY_USERNAME: (username: string, pageNumber: number) =>
      `${BASE_URL}/media/getMediaByInfluencer?Username=${username}&PageNumber=${pageNumber}`,
    GET_INFLUECER_SUBSCRIBED_POSTS_BY_USERNAME: (username: string, pageNumber: number) =>
      `${BASE_URL}/media/getInfluencerSubscribedMedia?Username=${username}&PageNumber=${pageNumber}`,
  },
  ORDER: {
    GET_PAYMENT_BY_ORDER_IDENTIFIER: (order_identifier: string) =>
      `${BASE_URL}/payment/${order_identifier}`,
  },
  PAYMENT: {
    MAKE_PAYMENT: `${BASE_URL}/payment/createpayment`,
    MAKE_SUBSCRIPTION_PAYMENT: `${BASE_URL}/payment/createSubscriptionPayment`,
  },
  POLL: {
    CREATE_POLL: `${BASE_URL}/poll/createpoll`,
    CREATE_POLL_OPTION: `${BASE_URL}/poll/createpolloption`,
    GET_POLLS_BY_IDENTIFIER: (identifier: number) =>
      `${BASE_URL}/poll/${identifier}`,
    GET_POLLS_BY_INFLUENCER: (identifier: number) =>
      `${BASE_URL}/poll/getpoll/${identifier}`,
    UPDATE_POLL_BY_IDENTIFIER: (identifier: number) =>
      `${BASE_URL}/poll/${identifier}`,
  },
  RAFFLE: {
    GET_INFLUENCER_RAFFLE: `${BASE_URL}/raffle/getRafflesByInfluencer`,
    GET_ALL_RAFFLE: `${BASE_URL}/raffle/getRaffles`,
    CREATE_RAFFLE: `${BASE_URL}/raffle/createraffle`,
    RAFFLE_BY_IDENTIFIER: (identifier: number) =>
      `${BASE_URL}/raffle/GetRaffle/${identifier}`,
    UPDATE_RAFFLE_BY_IDENTIFIER: (identifier: number) =>
      `${BASE_URL}/raffle/${identifier}`,
    DELETE_RAFFLE_IMAGE: (identifier: number) =>
      `${BASE_URL}/raffleimage/${identifier}`,
    RAFFLE_BY_SLUG: (slug: string) => `${BASE_URL}/raffle/${slug}`,
    GET_RAFFLES_BY_INFLUENCER: (username: string) =>
      `${BASE_URL}/raffle/getRafflesByInfluencer?UserName=${encodeURIComponent(
        username
      )}`,
  },
  SUBSCRIPTION: {
    CREATE_SUBSCRIPTION: `${BASE_URL}/subscription/createsubscription`,
    GET_SUBSCRIPTION_BY_ID: (identifier: number) =>
      `${BASE_URL}/subscription/GetSubscriptionById/${identifier}`,
    SUBSCRIPTION_BY_ID: (identifier: number) =>
      `${BASE_URL}/subscription/${identifier}`,
  },
  TICKET: {
    GET_USER_RAFFLE_TICKETS: `${BASE_URL}/RaffleTicket/GetRaffleTickets`,
    GET_RAFFLE_TICKETS: (slug: string) =>
      `${BASE_URL}/RaffleTicket/GetTicketsByRaffle/${slug}`,
  },
  USER: {
    USER_PROFILE: `${BASE_URL}/user`,
    GET_INFLUENCER_DETAILS: (username: string) =>
      `${BASE_URL}/user?UserName=${encodeURIComponent(username)}`,
    TRENDING_USER: `${BASE_URL}/user/GetTrendingUser`,
    GET_HOME_PAGE_USERS: `${BASE_URL}/user/GetHomePageUser`
  },
  USER_SUBSCRIPTION: {
    GET_SUBSCRIPTIONS_BY_USER: `${BASE_URL}/UserSubscription/GetUserSubscriptions`,
  },
  VOTE: {
    CAST_VOTE: `${BASE_URL}/vote/castvote`,
  },
};
